// source: core/protos/model_views.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var core_protos_camera_pb = require('../../core/protos/camera_pb.js');
goog.object.extend(proto, core_protos_camera_pb);
var core_protos_uuid_pb = require('../../core/protos/uuid_pb.js');
goog.object.extend(proto, core_protos_uuid_pb);
var google_protobuf_any_pb = require('google-protobuf/google/protobuf/any_pb.js');
goog.object.extend(proto, google_protobuf_any_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.vertexvis.protobuf.core.ItemModelView', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.ModelView', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.PmiAnnotation', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.ModelView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.ModelView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.ModelView.displayName = 'proto.vertexvis.protobuf.core.ModelView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.ItemModelView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.ItemModelView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.ItemModelView.displayName = 'proto.vertexvis.protobuf.core.ItemModelView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.PmiAnnotation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.PmiAnnotation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.PmiAnnotation.displayName = 'proto.vertexvis.protobuf.core.PmiAnnotation';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.ModelView.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.ModelView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.ModelView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.ModelView.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && core_protos_uuid_pb.Uuid2l.toObject(includeInstance, f),
    partRevisionId: (f = msg.getPartRevisionId()) && core_protos_uuid_pb.Uuid2l.toObject(includeInstance, f),
    displayName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    camera: (f = msg.getCamera()) && core_protos_camera_pb.Camera.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.ModelView}
 */
proto.vertexvis.protobuf.core.ModelView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.ModelView;
  return proto.vertexvis.protobuf.core.ModelView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.ModelView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.ModelView}
 */
proto.vertexvis.protobuf.core.ModelView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_uuid_pb.Uuid2l;
      reader.readMessage(value,core_protos_uuid_pb.Uuid2l.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = new core_protos_uuid_pb.Uuid2l;
      reader.readMessage(value,core_protos_uuid_pb.Uuid2l.deserializeBinaryFromReader);
      msg.setPartRevisionId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 4:
      var value = new core_protos_camera_pb.Camera;
      reader.readMessage(value,core_protos_camera_pb.Camera.deserializeBinaryFromReader);
      msg.setCamera(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.ModelView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.ModelView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.ModelView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.ModelView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_uuid_pb.Uuid2l.serializeBinaryToWriter
    );
  }
  f = message.getPartRevisionId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      core_protos_uuid_pb.Uuid2l.serializeBinaryToWriter
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCamera();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      core_protos_camera_pb.Camera.serializeBinaryToWriter
    );
  }
};


/**
 * optional Uuid2l id = 1;
 * @return {?proto.vertexvis.protobuf.core.Uuid2l}
 */
proto.vertexvis.protobuf.core.ModelView.prototype.getId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid2l} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid2l, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid2l|undefined} value
 * @return {!proto.vertexvis.protobuf.core.ModelView} returns this
*/
proto.vertexvis.protobuf.core.ModelView.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.ModelView} returns this
 */
proto.vertexvis.protobuf.core.ModelView.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.ModelView.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Uuid2l part_revision_id = 2;
 * @return {?proto.vertexvis.protobuf.core.Uuid2l}
 */
proto.vertexvis.protobuf.core.ModelView.prototype.getPartRevisionId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid2l} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid2l, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid2l|undefined} value
 * @return {!proto.vertexvis.protobuf.core.ModelView} returns this
*/
proto.vertexvis.protobuf.core.ModelView.prototype.setPartRevisionId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.ModelView} returns this
 */
proto.vertexvis.protobuf.core.ModelView.prototype.clearPartRevisionId = function() {
  return this.setPartRevisionId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.ModelView.prototype.hasPartRevisionId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string display_name = 3;
 * @return {string}
 */
proto.vertexvis.protobuf.core.ModelView.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.vertexvis.protobuf.core.ModelView} returns this
 */
proto.vertexvis.protobuf.core.ModelView.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Camera camera = 4;
 * @return {?proto.vertexvis.protobuf.core.Camera}
 */
proto.vertexvis.protobuf.core.ModelView.prototype.getCamera = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Camera} */ (
    jspb.Message.getWrapperField(this, core_protos_camera_pb.Camera, 4));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Camera|undefined} value
 * @return {!proto.vertexvis.protobuf.core.ModelView} returns this
*/
proto.vertexvis.protobuf.core.ModelView.prototype.setCamera = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.ModelView} returns this
 */
proto.vertexvis.protobuf.core.ModelView.prototype.clearCamera = function() {
  return this.setCamera(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.ModelView.prototype.hasCamera = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.ItemModelView.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.ItemModelView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.ItemModelView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.ItemModelView.toObject = function(includeInstance, msg) {
  var f, obj = {
    modelViewId: (f = msg.getModelViewId()) && core_protos_uuid_pb.Uuid2l.toObject(includeInstance, f),
    sceneItemId: (f = msg.getSceneItemId()) && core_protos_uuid_pb.Uuid2l.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.ItemModelView}
 */
proto.vertexvis.protobuf.core.ItemModelView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.ItemModelView;
  return proto.vertexvis.protobuf.core.ItemModelView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.ItemModelView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.ItemModelView}
 */
proto.vertexvis.protobuf.core.ItemModelView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_uuid_pb.Uuid2l;
      reader.readMessage(value,core_protos_uuid_pb.Uuid2l.deserializeBinaryFromReader);
      msg.setModelViewId(value);
      break;
    case 2:
      var value = new core_protos_uuid_pb.Uuid2l;
      reader.readMessage(value,core_protos_uuid_pb.Uuid2l.deserializeBinaryFromReader);
      msg.setSceneItemId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.ItemModelView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.ItemModelView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.ItemModelView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.ItemModelView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getModelViewId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_uuid_pb.Uuid2l.serializeBinaryToWriter
    );
  }
  f = message.getSceneItemId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      core_protos_uuid_pb.Uuid2l.serializeBinaryToWriter
    );
  }
};


/**
 * optional Uuid2l model_view_id = 1;
 * @return {?proto.vertexvis.protobuf.core.Uuid2l}
 */
proto.vertexvis.protobuf.core.ItemModelView.prototype.getModelViewId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid2l} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid2l, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid2l|undefined} value
 * @return {!proto.vertexvis.protobuf.core.ItemModelView} returns this
*/
proto.vertexvis.protobuf.core.ItemModelView.prototype.setModelViewId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.ItemModelView} returns this
 */
proto.vertexvis.protobuf.core.ItemModelView.prototype.clearModelViewId = function() {
  return this.setModelViewId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.ItemModelView.prototype.hasModelViewId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Uuid2l scene_item_id = 2;
 * @return {?proto.vertexvis.protobuf.core.Uuid2l}
 */
proto.vertexvis.protobuf.core.ItemModelView.prototype.getSceneItemId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid2l} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid2l, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid2l|undefined} value
 * @return {!proto.vertexvis.protobuf.core.ItemModelView} returns this
*/
proto.vertexvis.protobuf.core.ItemModelView.prototype.setSceneItemId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.ItemModelView} returns this
 */
proto.vertexvis.protobuf.core.ItemModelView.prototype.clearSceneItemId = function() {
  return this.setSceneItemId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.ItemModelView.prototype.hasSceneItemId = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.PmiAnnotation.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.PmiAnnotation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.PmiAnnotation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.PmiAnnotation.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && core_protos_uuid_pb.Uuid2l.toObject(includeInstance, f),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.PmiAnnotation}
 */
proto.vertexvis.protobuf.core.PmiAnnotation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.PmiAnnotation;
  return proto.vertexvis.protobuf.core.PmiAnnotation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.PmiAnnotation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.PmiAnnotation}
 */
proto.vertexvis.protobuf.core.PmiAnnotation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_uuid_pb.Uuid2l;
      reader.readMessage(value,core_protos_uuid_pb.Uuid2l.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.PmiAnnotation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.PmiAnnotation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.PmiAnnotation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.PmiAnnotation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_uuid_pb.Uuid2l.serializeBinaryToWriter
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional Uuid2l id = 1;
 * @return {?proto.vertexvis.protobuf.core.Uuid2l}
 */
proto.vertexvis.protobuf.core.PmiAnnotation.prototype.getId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid2l} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid2l, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid2l|undefined} value
 * @return {!proto.vertexvis.protobuf.core.PmiAnnotation} returns this
*/
proto.vertexvis.protobuf.core.PmiAnnotation.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.PmiAnnotation} returns this
 */
proto.vertexvis.protobuf.core.PmiAnnotation.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.PmiAnnotation.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.vertexvis.protobuf.core.PmiAnnotation.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.vertexvis.protobuf.core.PmiAnnotation} returns this
 */
proto.vertexvis.protobuf.core.PmiAnnotation.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


goog.object.extend(exports, proto.vertexvis.protobuf.core);
